<div>
    <div class="page_title">
        <div class="row marges">
            <div class="col y_items_center">
                @switch (true) {

                    @case (mode === 'personnal-offers') {

                        <div class="personal_offers">

                            @if(!userService.hasAccess(user, 'SOCIETY_SUBSCRIPTION_LIST_IS_MINE')) {

                                <div class="row">
                                    <h1 class="title">{{ 'offer.reservoir.offerCreator.value' | translate }}</h1>
                                </div>
                            }

                            @if(userService.hasAccess(user, 'SOCIETY_SUBSCRIPTION_LIST_IS_MINE')) {

                                <div class="row">
                                    <h1 class="title">{{ 'offer.reservoir.offerCreator.value' | translate }} ({{ offerSearchService.totalFilteredOffers }} <span>{{ offerSearchService.totalFilteredOffers | translationFromQuantity:'offer.catalog.offerCreator.total.empty.value':'offer.catalog.offerCreator.total.singular.value':'offer.catalog.offerCreator.total.plural.value' }}</span>)</h1>
                                </div>

                                @if(currentValidSocietySubscription) {
                                    <div class="licences">
                                        @if(currentValidSocietySubscription.subscription.isUnlimitedMaxOffer) {
                                            <span> {{ 'offers.published.value' | translate }} {{ society.countPublishedOffers }}</span>
                                        } @else {
                                            <span> {{ 'offers.published.value' | translate }} {{ society.countPublishedOffers }} / {{ currentValidSocietySubscription.subscription.maxOffer }}</span>
                                        }
                                    </div>
                                }
                            }

                        </div>
                    }

                    @case (mode === 'reservoir' && hasRole('ROLE_PROVIDER')) {
                        <h1 class="title">{{ 'offer.reservoir.provider.value' | translate }}</h1>
                    }

                    @case (mode === 'reservoir' && !hasRole('ROLE_PROVIDER')) {
                        <h1 class="title">{{ 'offer.reservoir.value' | translate }}</h1>
                    }

                    @case (mode === 'catalog' || mode === 'channel') {
                        <div class="catalog">

                            @if(!userService.hasAccess(user, 'SOCIETY_SUBSCRIPTION_LIST_IS_MINE')) {

                                <div class="row">
                                    <h1 class="title">{{ 'offer.reservoir.offerCreator.value' | translate }}</h1>
                                </div>

                            } @else {

                                <div class="row">
                                    <h1 class="title">{{ 'offer.catalog.offerCreator.value' | translate }} ({{ offerSearchService.totalFilteredOffers }} <span>{{ offerSearchService.totalFilteredOffers | translationFromQuantity:'offer.catalog.offerCreator.total.empty.value':'offer.catalog.offerCreator.total.singular.value':'offer.catalog.offerCreator.total.plural.value' }}</span>)</h1>
                                </div>

                                @if(society.restrictedOfferQuota && hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_FEDERATION', 'ROLE_INSTITUTIONAL'])) {

                                    <div class="licences">

                                        <span>{{ 'society.restrictedQuota.value' | translate}} : {{ society.countRestrictedCatalogOffers }}/{{ society.restrictedOfferQuota }} </span>

                                    </div>
                                }
                            }

                        </div>
                    }
                }

            </div>
            <div class="col_content y_items_center">

                @if(origin) {

                    <!-- Retour à l'origine -->

                    <button class="btn_cta btn_lines btn_little" type="button" (click)="redirectToOrigin()">
                        {{ origin.backLabel | translate }}
                    </button>
                }

                <!-- Demande d'accès multiple -->

                @if(userService.hasAccess(user, 'OFFER_CATALOG_CREATE') && (hasRole('ROLE_OFFER_DISTRIBUTOR') || hasRole('ROLE_INSTITUTIONAL') || hasRole('ROLE_FEDERATION'))) {

                    @if(offerSearchService.multipleAccessRequestSelectionActivated.getValue()) {

                        <button class="btn_cta btn_small" (click)="cancelMultipleAccessRequestSelection()">
                            {{ 'offer.accessRequest.multiple.cancel.action.value' | translate }}
                        </button>

                        <button class="btn_cta btn_small" [disabled]="!offerSearchService.selectedAccessRequestOffers.getValue().length" (click)="addMultipleOffersToCatalog(offerSearchService.selectedAccessRequestOffers.getValue())">
                            {{ 'offer.accessRequest.multiple.confirm.action.value' | translate }}
                        </button>

                    } @else {

                        @if(mode === 'reservoir') {

                            <button class="btn_cta btn_little" (click)="activateMultipleAccessRequestSelection()">
                                {{ 'offer.accessRequest.multiple.value' | translate }}
                            </button>
                        }
                    }
                }

                @if(hasRole('ROLE_OFFER_CREATOR')) {

                    <!-- Création d'une offre -->

                    @if(userService.hasAccess(user, 'OFFER_CREATE_IS_MINE')) {
                        <button (click)="addItem()" class="btn_cta btn_little btn_add">
                            {{ 'offer.create.action.value' | translate }}
                        </button>
                    }
                }

                @if(mode === 'catalog' && isQuotationCreationAllowed) {
                    <!-- Demande sur-mesure -->

                    <button (click)="openCreateQuotationDialog()" class="btn_cta btn_little btn_add">
                        {{ 'quotation.create' | translate }}
                    </button>
                }

                @if(mode === 'catalog' && isTenderCreationAllowed) {
                    <!-- Demande de création d’offres -->

                    <button (click)="openCreateTenderDialog()" class="btn_cta btn_little btn_add">
                        {{ 'tender.value' | translate }}
                    </button>
                }

            </div>
        </div>
    </div>

    @if((hasRole('ROLE_INSTITUTIONAL') || hasRole('ROLE_FEDERATION')) && (offerSearchService.totalFilteredOffers === 0)) {
        <div class="subscription_information">
            <p [innerHTML]="'offer.access.support.contact.value' | translate"></p>
        </div>
    }

    @if(isPremiumSubscription && mode === 'personnal-offers' && displaySubscriptionInformation$ | async) {
        <div class="subscription_information">
            {{ 'offer.reservoir.subscriptionInformation.value' | translate }}
        </div>
    }

    <!-- Liste des offres -->

    <app-core-offer-search
        [user]="user"
        [society]="society"
        [mode]="mode"
    ></app-core-offer-search>
</div>

